import React, { useState } from 'react';
import { Accordion, Card, useAccordionButton } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import './faqWidget.scss';

function CustomToggle({ children, callback, eventKey, isExpanded }) {
    const decoratedOnClick = useAccordionButton(eventKey);
    const arrow = isExpanded ? <ChevronUp /> : <ChevronDown />;

    return (
        <Card.Header
            onClick={() => {
                decoratedOnClick();
                callback(eventKey);
            }}
        >
            {children}
            {arrow}
        </Card.Header>
    );
}

CustomToggle.propTypes = {
    callback: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    eventKey: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool.isRequired
};

function FaqWidget({ dataType }) {
    const [openKeys, setOpenKeys] = useState([]);
    const { t } = useTranslation();

    let faqData = [
        {
            title: t('web-hosting-page.faq-column.title-1'),
            text: t('web-hosting-page.faq-column.text-1')
        },
        {
            title: t('web-hosting-page.faq-column.title-2'),
            text: t('web-hosting-page.faq-column.text-2')
        },
        {
            title: t('web-hosting-page.faq-column.title-3'),
            text: t('web-hosting-page.faq-column.text-3')
        },
        {
            title: t('web-hosting-page.faq-column.title-4'),
            text: t('web-hosting-page.faq-column.text-4')
        },
        {
            title: t('web-hosting-page.faq-column.title-5'),
            text: t('web-hosting-page.faq-column.text-5')
        },
        {
            title: t('web-hosting-page.faq-column.title-6'),
            text: t('web-hosting-page.faq-column.text-6')
        },
        {
            title: t('web-hosting-page.faq-column.title-7'),
            text: t('web-hosting-page.faq-column.text-7')
        },
        {
            title: t('web-hosting-page.faq-column.title-8'),
            text: t('web-hosting-page.faq-column.text-8')
        }
    ];

    const resellerData = [
        {
            title: t('reseller-hosting-page.faq-column.title-1'),
            text: t('reseller-hosting-page.faq-column.text-1')
        },
        {
            title: t('reseller-hosting-page.faq-column.title-2'),
            text: t('reseller-hosting-page.faq-column.text-2')
        },
        {
            title: t('reseller-hosting-page.faq-column.title-3'),
            text: t('reseller-hosting-page.faq-column.text-3')
        },
        {
            title: t('reseller-hosting-page.faq-column.title-4'),
            text: t('reseller-hosting-page.faq-column.text-4')
        },
        {
            title: t('reseller-hosting-page.faq-column.title-5'),
            text: t('reseller-hosting-page.faq-column.text-5')
        },
        {
            title: t('reseller-hosting-page.faq-column.title-6'),
            text: t('reseller-hosting-page.faq-column.text-6')
        }
    ];

    const emailData = [
        {
            title: t('email-page.faq-column.title-1'),
            text: t('email-page.faq-column.text-1')
        },
        {
            title: t('email-page.faq-column.title-2'),
            text: t('email-page.faq-column.text-2')
        },
        {
            title: t('email-page.faq-column.title-3'),
            text: t('email-page.faq-column.text-3')
        },
        {
            title: t('email-page.faq-column.title-4'),
            text: t('email-page.faq-column.text-4')
        },
        {
            title: t('email-page.faq-column.title-5'),
            text: t('email-page.faq-column.text-5')
        },
        {
            title: t('email-page.faq-column.title-6'),
            text: t('email-page.faq-column.text-6')
        },
        {
            title: t('email-page.faq-column.title-7'),
            text: t('email-page.faq-column.text-7')
        }
    ];

    const domainData = [
        {
            title: t('domain-page.faq-column.title-1'),
            text: t('domain-page.faq-column.text-1')
        },
        {
            title: t('domain-page.faq-column.title-2'),
            text: t('domain-page.faq-column.text-2')
        },
        {
            title: t('domain-page.faq-column.title-3'),
            text: t('domain-page.faq-column.text-3')
        },
        {
            title: t('domain-page.faq-column.title-4'),
            text: t('domain-page.faq-column.text-4')
        },
        {
            title: t('domain-page.faq-column.title-5'),
            text: t('domain-page.faq-column.text-5')
        },
        {
            title: t('domain-page.faq-column.title-6'),
            text: t('domain-page.faq-column.text-6')
        }
    ];

    const vpsData = [
        {
            title: t('vps-page.faq-column.title-1'),
            text: t('vps-page.faq-column.text-1')
        },
        {
            title: t('vps-page.faq-column.title-2'),
            text: t('vps-page.faq-column.text-2')
        },
        {
            title: t('vps-page.faq-column.title-3'),
            text: t('vps-page.faq-column.text-3')
        },
        {
            title: t('vps-page.faq-column.title-4'),
            text: t('vps-page.faq-column.text-4')
        },
        {
            title: t('vps-page.faq-column.title-5'),
            text: t('vps-page.faq-column.text-5')
        },
        {
            title: t('vps-page.faq-column.title-6'),
            text: t('vps-page.faq-column.text-6')
        },
        {
            title: t('vps-page.faq-column.title-7'),
            text: t('vps-page.faq-column.text-7')
        },
        {
            title: t('vps-page.faq-column.title-8'),
            text: t('vps-page.faq-column.text-8')
        }
    ];

    const affiliateData = [
        {
            title: t('affiliate-page.faq-column.title-1'),
            text: t('affiliate-page.faq-column.text-1')
        },
        {
            title: t('affiliate-page.faq-column.title-2'),
            text: t('affiliate-page.faq-column.text-2')
        },
        {
            title: t('affiliate-page.faq-column.title-3'),
            text: t('affiliate-page.faq-column.text-3')
        },
        {
            title: t('affiliate-page.faq-column.title-4'),
            text: t('affiliate-page.faq-column.text-4')
        },
        {
            title: t('affiliate-page.faq-column.title-5'),
            text: t('affiliate-page.faq-column.text-5')
        }
    ];

    if (dataType === 'reseller') {
        faqData = resellerData;
    } else if (dataType === 'email') {
        faqData = emailData;
    } else if (dataType === 'domain') {
        faqData = domainData;
    } else if (dataType === 'vps') {
        faqData = vpsData;
    } else if (dataType === 'affiliate') {
        faqData = affiliateData;
    }

    const handleToggle = (eventKey) => {
        setOpenKeys((prevOpenKeys) =>
            prevOpenKeys.includes(eventKey)
                ? prevOpenKeys.filter((key) => key !== eventKey)
                : [...prevOpenKeys, eventKey]
        );
    };
    const renderFaqItem = (item, index) => {
        const eventKey = String(index);
        const isExpanded = openKeys.includes(eventKey);

        return (
            <Card key={`${item.title}-${index}`}>
                <CustomToggle
                    eventKey={String(index)}
                    callback={handleToggle}
                    isExpanded={isExpanded}
                >
                    {item.title}
                </CustomToggle>
                <Accordion.Collapse eventKey={String(index)}>
                    <Card.Body>{item.text}</Card.Body>
                </Accordion.Collapse>
            </Card>
        );
    };

    return (
        <div className="faq-rows-wrapper">
            <Accordion>{faqData.map(renderFaqItem)}</Accordion>
        </div>
    );
}

FaqWidget.propTypes = {
    dataType: PropTypes.string
};

FaqWidget.defaultProps = {
    dataType: 'web'
};

export default FaqWidget;
